<div class="layout-auto-1-auto">
  <div *ngIf="changed" (click)="saveData()" class="fixed-fab bottom-right ng-star-inserted"><i class="fal fa-save"></i></div>
  <div class="content">
    <h5>Allgemein</h5>
    <div class="grid cols-6">
      <div class="span-3">
        <exg-input caption="Wert 1914" name="value1914" type="number" [step]="0.01"
                   [(ngModel)]="GlobalSettingsObject.setWert1914Faktor">

        </exg-input>
      </div>
      <div class="span-3">
        <label class="fs-small">In diesem Bereich finden Sie die allgemeinen Einstellungen für EXAKT. Sie können beispielsweise Faktor des Wert 1914 anpassen.</label>
      </div>
    </div>
  </div>
</div>
